var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, makeObservable } from 'mobx';
import { MedFile } from '../medFile/MedFile';
import { editable } from '../../../../utils/mobx/decorators/editable';
import { TimeMark } from '../vid/TimeMark';
import { TimeRange } from '../vid/TimeRange';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { withDefault } from '../../../../utils/serializr/schema/middle/withDefault';
import { primitive } from '../../../../utils/serializr/schema/inner/primitive';
import { alias } from '../../../../utils/serializr/schema/middle/alias';
import { list } from '../../../../utils/serializr/schema/list';
import { object } from '../../../../utils/serializr/schema/object';
import { withInit } from '../../../../utils/serializr/schema/middle/withInit';
export class Ply extends MedFile {
    durationInSeconds = 0;
    timeMarks = observable.array();
    timeRanges = observable.array();
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    static get serializeInfo() {
        return {
            extends: MedFile.serializeInfo,
            props: {
                durationInSeconds: alias('duration', withInit(primitive, 0)),
                timeMarks: withDefault(list(object(TimeMark)), []),
                timeRanges: withDefault(list(object(TimeRange)), []),
            },
        };
    }
}
__decorate([
    editable()
], Ply.prototype, "durationInSeconds", void 0);
__decorate([
    editable('shallow')
], Ply.prototype, "timeMarks", void 0);
__decorate([
    editable('shallow')
], Ply.prototype, "timeRanges", void 0);
__decorate([
    memoize
], Ply, "serializeInfo", null);
